"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ListboxPagination_component_exports = {};
__export(ListboxPagination_component_exports, {
  ListboxPagination: () => ListboxPagination,
  default: () => ListboxPagination_component_default
});
module.exports = __toCommonJS(ListboxPagination_component_exports);
var import_react = __toESM(require("react"));
var import_useEventListener = require("../../../utils/useEventListener/useEventListener.hook");
var import_react2 = require("react");
var import_react_i18next = require("react-i18next");
var import_i18n = __toESM(require("../../../i18n"));
var import_ListboxPagination = require("./ListboxPagination.styled");
var _excluded = ["currentPage", "darkMode", "prevButtonAriaLabel", "nextButtonAriaLabel"];
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r)
      return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r))
    return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var itemsPerPageOptions = [10, 25, 50];
var randomId = "".concat(Math.floor(Math.random() * 1e6));
var ListboxPagination = function ListboxPagination2(_ref) {
  var _ref$currentPage = _ref.currentPage, currentPage = _ref$currentPage === void 0 ? 1 : _ref$currentPage, _ref$darkMode = _ref.darkMode, darkMode = _ref$darkMode === void 0 ? false : _ref$darkMode, prevButtonAriaLabel = _ref.prevButtonAriaLabel, nextButtonAriaLabel = _ref.nextButtonAriaLabel, props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, import_react2.useState)(), _useState2 = _slicedToArray(_useState, 2), activePage = _useState2[0], setActivePage = _useState2[1];
  var _useState3 = (0, import_react2.useState)(), _useState4 = _slicedToArray(_useState3, 2), totalPages = _useState4[0], setTotalPages = _useState4[1];
  var _useState5 = (0, import_react2.useState)(10), _useState6 = _slicedToArray(_useState5, 2), itemsPerPage = _useState6[0], setItemsPerPage = _useState6[1];
  var _useState7 = (0, import_react2.useState)(false), _useState8 = _slicedToArray(_useState7, 2), alignCenter = _useState8[0], setAlignCenter = _useState8[1];
  var paginationRef = (0, import_react2.useRef)(null);
  var manageAlignment = function manageAlignment2(width) {
    if (width < 500 && !alignCenter) {
      setAlignCenter(true);
    } else if (width >= 500 && alignCenter) {
      setAlignCenter(false);
    }
  };
  var onPageChange = function onPageChange2(page) {
    setActivePage(page);
    if (props.onPageChange) {
      props.onPageChange(page);
    }
  };
  (0, import_react2.useEffect)(function() {
    if (paginationRef.current) {
      manageAlignment(paginationRef.current.clientWidth);
    }
  }, [paginationRef]);
  var getPageCount = function getPageCount2() {
    var pageCount = 1;
    if (!Number.isNaN(Number(props.totalItems)) && Number(props.totalItems) > 0) {
      pageCount = Math.ceil(props.totalItems / itemsPerPage);
    }
    return pageCount;
  };
  (0, import_react2.useEffect)(function() {
    var pageCount = getPageCount();
    if (pageCount !== totalPages) {
      setTotalPages(pageCount);
    }
    if (currentPage !== activePage) {
      if (Number.isNaN(Number(currentPage)) || Number(currentPage) < 1) {
        onPageChange(1);
      } else if (Number(currentPage) > pageCount) {
        onPageChange(pageCount);
      } else {
        setActivePage(currentPage);
      }
    }
  }, [props.totalItems, currentPage]);
  (0, import_react2.useEffect)(function() {
    var pageCount = getPageCount();
    if (pageCount !== totalPages) {
      setTotalPages(pageCount);
    }
    if (activePage > pageCount) {
      setActivePage(pageCount);
    }
  }, [itemsPerPage]);
  (0, import_useEventListener.useEventListener)("resize", function() {
    if (paginationRef.current) {
      manageAlignment(paginationRef.current.clientWidth);
    }
  });
  var handleLastPageClick = function handleLastPageClick2() {
    onPageChange(totalPages);
  };
  var handlePageSelected = function handlePageSelected2(selection) {
    if (selection) {
      return selection.value;
    }
    return void 0;
  };
  var onPageSelect = function onPageSelect2(selected) {
    if (selected[0] && selected[0] !== "undefined" && Number(selected[0]) !== activePage) {
      onPageChange(Number(selected[0]));
    }
  };
  var onPreviousButtonClick = function onPreviousButtonClick2() {
    if (activePage > 1) {
      onPageChange(activePage - 1);
    }
  };
  var onNextButtonClick = function onNextButtonClick2() {
    if (activePage < totalPages) {
      onPageChange(activePage + 1);
    }
  };
  var onItemsPerPageChange = function onItemsPerPageChange2(selected) {
    var updatedItemsPerPage = Number(selected[0]);
    if (updatedItemsPerPage !== itemsPerPage) {
      setItemsPerPage(updatedItemsPerPage);
    }
  };
  var _useTranslation = (0, import_react_i18next.useTranslation)(), t = _useTranslation.t;
  return /* @__PURE__ */ import_react.default.createElement(import_react_i18next.I18nextProvider, {
    i18n: import_i18n.default
  }, /* @__PURE__ */ import_react.default.createElement(import_ListboxPagination.StyledPaginationContainer, {
    "data-testid": "pagination-container",
    ref: paginationRef,
    withAlignCenter: alignCenter
  }, /* @__PURE__ */ import_react.default.createElement(import_ListboxPagination.StyledPagesContainer, null, /* @__PURE__ */ import_react.default.createElement(import_ListboxPagination.StyledLeftIconButton, {
    darkMode,
    disabled: activePage === 1,
    icon: "chevron-back",
    "data-testid": "pagination-button-previous",
    "aria-label": prevButtonAriaLabel || t("base_action_previous"),
    onClick: onPreviousButtonClick,
    dataDpAnalyticsId: props.prevButtonDataDpAnalyticsId
  }), /* @__PURE__ */ import_react.default.createElement(import_ListboxPagination.StyledInputCombobox, {
    isListboxPagination: true,
    onSelect: onPageSelect,
    darkMode,
    defaultSelected: ["".concat(activePage)],
    inputSize: "".concat(activePage).length,
    handleSelection: handlePageSelected,
    dataDpAnalyticsId: props.inputComboboxDataDpAnalyticsId,
    id: props.id || "inputCombobox-".concat(randomId)
  }, Array.from({
    length: totalPages
  }, function(x, i) {
    return i + 1;
  }).map(function(pageNumber) {
    return /* @__PURE__ */ import_react.default.createElement(import_ListboxPagination.StyledInputCombobox.Option, {
      key: pageNumber,
      id: pageNumber,
      value: "".concat(pageNumber),
      dataDpAnalyticsId: "".concat(props.optionInputComboboxDataDpAnalyticsId ? props.optionInputComboboxDataDpAnalyticsId : "analytics-page-").concat(pageNumber)
    }, "Page ".concat(pageNumber));
  })), /* @__PURE__ */ import_react.default.createElement(import_ListboxPagination.StyledSeparator, {
    darkMode
  }, "/"), /* @__PURE__ */ import_react.default.createElement(import_ListboxPagination.StyledLink, {
    size: "medium",
    isDisabled: activePage === totalPages,
    onClick: handleLastPageClick,
    darkMode,
    "data-testid": "last-page-link",
    href: "#",
    dataDpAnalyticsId: props.lastPageLinkDataDpAnalyticsId
  }, totalPages), /* @__PURE__ */ import_react.default.createElement(import_ListboxPagination.StyledRightIconButton, {
    darkMode,
    disabled: activePage === totalPages,
    icon: "chevron-front",
    "data-testid": "pagination-button-next",
    "aria-label": nextButtonAriaLabel || t("base_action_next"),
    onClick: onNextButtonClick,
    dataDpAnalyticsId: props.nextButtonDataDpAnalyticsId
  })), /* @__PURE__ */ import_react.default.createElement(import_ListboxPagination.StyledComboboxSelect, {
    label: t("dp_core_listboxPagination_itemsPerPage_aria"),
    "data-testid": "pagination-label-itemsPerPage",
    labelWithin: false,
    onSelect: onItemsPerPageChange,
    defaultSelected: [itemsPerPage],
    darkMode,
    listBoxPlacement: "top",
    dataDpAnalyticsId: props.comboboxSelectDataDpAnalyticsId,
    id: props.id || "comboboxSelect-".concat(randomId)
  }, itemsPerPageOptions.map(function(option) {
    return /* @__PURE__ */ import_react.default.createElement(import_ListboxPagination.StyledComboboxSelect.Option, {
      key: option,
      id: "".concat(option, "-items-per-page"),
      value: option,
      dataDpAnalyticsId: props.optionComboboxSelectDataDpAnalyticsId && "".concat(props.optionComboboxSelectDataDpAnalyticsId).concat(option)
    }, option);
  }))));
};
var ListboxPagination_component_default = ListboxPagination;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ListboxPagination
});
//# sourceMappingURL=ListboxPagination.component.js.map